import { type FC, type ReactNode } from 'react'
import { PlaidMultiLinkContextProvider } from '../plaid-multi-link-context/plaid-multi-link-context'
import { PlaidMultiLinkModal } from '../plaid-multi-link-modal/plaid-multi-link-modal'

// Wrapper component that provides the context and includes the modal
export const PlaidMultiLinkWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <PlaidMultiLinkContextProvider>
      {children}
      <PlaidMultiLinkModal />
    </PlaidMultiLinkContextProvider>
  )
}
